import { observable, action, toJS, makeObservable, override } from 'mobx';
import ObjectListStore from './ObjectList';
import FormStore from './FormStore';

class DriverSuspensionStore extends ObjectListStore {
  DEFAULT = {
    baseUrl: '/driver-suspensions',
    fields: [
      { name: 'driver_id', orderField: 'driver_id', label: 'Driver ID', hightlight: true, toggleOrder: this.toggleOrder },
      { name: 'driver_name', label: 'Driver Name' },
      { name: 'reason', label: 'Reason' },
      { name: 'category', label: 'Category' },
      { name: 'suspension_type', label: 'Probation Type' },
      { name: 'action_level', label: 'Action Level' },
      { name: 'start_time', label: 'Start Time' },
      { name: 'end_time', label: 'End Time' },
      { name: 'reporter_id', label: 'Report By' },
      { name: 'reporter_ts', label: 'Report At' },
      { name: 'email_action', label: 'Email Action' },
      { name: 'actions', label: '#' },
    ],
    filters: {
      order_by: 'reporter_ts',
      desc: true,
      page: 1,
      size: 20,
    },
    filterReason: '',
    fieldFilterComponents: {},
    result: {
      count: 0,
      items: [],
      total_pages: 0,
    },
    listField: 'items',
    idField: 'id',
  };

  SCHEDULE = {
    baseUrl: '/driver-suspensions',
    fields: [
      { name: 'driver_id', orderField: 'driver_id', label: 'Driver ID', hightlight: true, toggleOrder: this.toggleOrder },
      { name: 'driver_name', label: 'Driver Name' },
      { name: 'reason', label: 'Reason' },
      { name: 'category', label: 'Category' },
      { name: 'suspension_type', label: 'Probation Type' },
      { name: 'start_time', label: 'Start Time' },
      { name: 'end_time', label: 'End Time' },
      { name: 'value', label: 'Info' },
      { name: 'reporter_id', label: 'Reported By' },
      { name: 'reporter_ts', label: 'Reported At' },
      { name: 'actions', label: '#' },
    ],
    filters: {
      order_by: 'reporter_ts',
      desc: true,
      page: 1,
      size: 20,
    },
    result: {
      count: 0,
      items: [],
      total_pages: 0,
    },
    listField: 'items',
    idField: 'id',
  };

  constructor(api, parent) {
    super(api);

    makeObservable(this, {
      driverSuspension: observable,
      probationLoading: observable,
      probationEmails: observable,
      probationEmailSending: observable,
      processData: action,
      search: override,
    });

    this.setData(this.DEFAULT);
    this.formStore = new FormStore(this);
    this.isLoading = false;
    if (!parent) {
      this.schedule = new DriverSuspensionStore(api, this);
      this.schedule.setType('SCHEDULE');
    }
  }

  driverSuspension = null;

  handleErrors = (data) => {
    const errors = data?.message || data?.errors;
    if (errors) {
      this.formStore.errors = Array.isArray(errors) ? errors : [errors];
    }
  };

  create(cb) {
    this.isLoading = true;
    const data = this.formStore.data;
    this.api
      .post(this.baseUrl, data)
      .then((response) => {
        this.isLoading = false;
        cb?.(response);

        if (!response.ok) {
          this.handleErrors(response.data);
        }
      })
      .catch((error) => {
        this.isLoading = false;
        this.formStore.errors = ['An unexpected error occurred. Please try again.'];
      });
  }

  edit(id, cb) {
    this.isLoading = true;
    const data = this.formStore.data;
    this.api
      .put(`${this.baseUrl}/${id}`, data)
      .then((response) => {
        this.isLoading = false;
        cb?.(response);

        if (!response.ok) {
          this.handleErrors(response.data);
        }
      })
      .catch((error) => {
        this.isLoading = false;
        this.formStore.errors = ['An unexpected error occurred. Please try again.'];
      });
  }

  get(id, cb) {
    this.api.get(`${this.baseUrl}/${id}`).then((response) => {
      if (response.status === 200) {
        this.driverSuspension = response.data;
        if (cb) {
          cb(response.data);
        }
      }
    });
  }

  delete(id, cb) {
    this.api.delete(`${this.baseUrl}/${id}`).then((response) => {
      if (cb) {
        cb(response);
      }
    });
  }

  //Todo list probation email template
  probationLoading = false;
  probationEmails = [];

  listProbationEmailTemplate(type = 'PROBATION', cb = () => {}) {
    this.probationLoading = true;
    const params = new URLSearchParams();
    params.append('type', type);

    this.api.get(`/driver-suspensions/action_emails/templates`, params).then((res) => {
      if (res.status === 200 || res.ok) {
        this.probationEmails = res.data;

        this.probationLoading = false;
      }

      if (cb) cb(res);
    });
  }

  //Todo Send probation emails
  probationEmailSending = false;

  sendDisciplinaryEmails(queryParams, cb = () => {}) {
    this.probationEmailSending = true;
    if (!queryParams && (!queryParams.emailTemplateId || !queryParams.ids.length)) {
      this.probationEmailSending = false;
      return;
    }

    this.api.post(`/driver-suspensions/disciplinary_emails/send`, queryParams).then((res) => {
      if (res.status === 200 || res.ok) {
        this.probationEmailSending = false;
      }

      if (cb) cb(res);
    });
  }

  processData = (response, cb) => {
    if (response.status === 200) {
      if (this.processResult) {
        this.processResult(response.data, this);
      } else {
        if (Array.isArray(response.data)) {
          this.result = {
            items: response.data,
            count: response.data.length,
            total_pages: 1,
          };
        } else {
          let result = {
            items: response.data[this.listField],
            count: response.data.count ? response.data.count : response.data[this.listField].length,
            total_pages: response.data.count && this.filters.size ? Math.ceil(response.data.count / this.filters.size) : 1,
          };

          this.result = { ...response.data, ...result };
        }

        this.result.data = response.data;
      }

      if (cb) cb(response);
    }
  };

  search(cb) {
    this.searching = true;
    this.selectedItems = [];
    const processedFilters = {};
    const filters = toJS(this.filters);
    const driver_info = new URLSearchParams(window.location.search).get('q');

    Object.keys(filters).forEach((key) => {
      if (Array.isArray(filters[key]) && filters[key].length == 0) {
        return;
      }

      if (!!filters[key] !== false) {
        processedFilters[key] = filters[key];
      }
    });

    if (processedFilters.page && processedFilters.page > 0) {
      processedFilters.page = processedFilters.page - 1;
    }

    if (driver_info) {
      processedFilters.driver_info = driver_info;
    }

    if (this.type && this.type.toLowerCase() === 'schedule') {
      this.api.get(this.baseUrl, filters).then((response) => {
        this.searching = false;
        this.processData(response, cb);
      });
    } else {
      this.api.post('/driver-suspensions/search', processedFilters).then((response) => {
        this.searching = false;
        this.processData(response, cb);
      });
    }
  }

  getLatestEmailBySuspension = (suspensionId, cb) => {
    this.api.get(`/driver-suspensions/${suspensionId}/latest-email`).then((res) => {
      if (res.status === 200 || res.ok) {
        if (cb) cb(res.data);
      }
    });
  };
}

export default DriverSuspensionStore;
